<template>
  <v-container style="width:500px">
    <v-card class="mt-1" v-for="(person,index) in persons" :key="index">
      <v-card-title>{{person.name}}</v-card-title>
      <v-card-subtitle>{{person.title}}</v-card-subtitle>
      
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    persons: [
      { title: "Presidente", name: "Lic. Manuel Alberto O'Reilly Attolini" },
      { title: "Secretario", name: "Lic. Elsa Ordoñez Ordoñez" },
      { title: "Tesorero", name: "Lic. Luis Calderón De Anda" },
      { title: "Primer Vocal", name: "Lic. Maria Antonieta Arzate Valles" },
      { title: "Segundo Vocal", name: "Lic. Carlos Alejandro Garza Sáenz" }
    ]
  })
};
</script>

<style>
</style>